var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPickupPathFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5894,
    r: 10,
    fill: "#E7F9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4308 9.62668L10.5542 4.79668C10.3908 4.63334 10.1692 4.52834 9.93585 4.54584C9.70251 4.54584 9.48085 4.63918 9.31751 4.80251L4.53418 9.63251L5.77668 10.8633L9.06668 7.53834V16.6383H10.8167V7.52668L14.1942 10.8692L15.425 9.62668H15.4308Z",
    fill: "#13C097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPickupPathFill);
export default __webpack_public_path__ + "static/media/ic_pickup_path_fill.c5e7ba090250147069fb6c1c0c148f62.svg";
export { ForwardRef as ReactComponent };